var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07243 7.94768C4.69819 8.32194 4.69819 8.92872 5.07243 9.30297L10.8224 15.053C11.1967 15.4272 11.8035 15.4272 12.1777 15.053L17.9277 9.30297C18.3019 8.92872 18.3019 8.32194 17.9277 7.94768C17.5535 7.57343 16.9467 7.57343 16.5724 7.94768L11.5001 13.0201L6.42773 7.94768C6.05347 7.57343 5.44669 7.57343 5.07243 7.94768Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.4ce2546ee569a90e934346f8dcb83d95.svg";
export { ForwardRef as ReactComponent };